import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Storage from '../Helpers/Storage/Storage';
import {
  AlertForm, FormInput, FormCardGroup, FormTextarea,
  CheckboxValues, RadioValues, FormButton, FormImage
} from '../Helpers/Form';
import * as Actions from '../../actions/actions';
import AutoComplete from '../Helpers/AutoComplete';
import SingleChoise from '../Helpers/Storage/SingleChoise.json';
import HouseSituation from '../Helpers/Storage/HouseSituation.json';
import LandScapeSituation from '../Helpers/Storage/LandScapeSituation.json';
import Gender from '../Helpers/Storage/Gender.json';

class UserSettings extends Component {
  constructor(props) {
    super(props);
    props.getUser();
  }

  render() {
    const {
      userSettingsChange,
      updateUsersettings,
      dropUserimage,
      currentUserVm,
    } = this.props;

    const
      {
        houseSituation,
        gender, birthday, place, aboutMe, displayName, isPate,
        isOwner, photoURL, pricePerNight, pricePerDayAtMe, pricePerDayAtYou, priceClean,
        landScapeSituation
      } = currentUserVm;
    return (
      <div className="usersettings">
        <h1>Öffentliches Profil</h1>
        <AlertForm
          onSubmit={() => updateUsersettings({
            ...currentUserVm,
            isOwner: currentUserVm.isOwner.size !== 0,
            isPate: currentUserVm.isPate.size !== 0
          })}
          onChange={({ name, value }) => userSettingsChange(name, value)}
        >
          <FormImage
            onDrop={dropUserimage}
            image={photoURL || (Storage.has(gender) ? Storage.get(gender) : Storage.get('user'))}
            className="avatar"
          />
          <FormInput required name="displayName" text="Anzeigename" type="text" value={displayName} />
          <FormCardGroup type="card" text="Geschlecht">
            <RadioValues selectedValue={gender} possibleValues={Gender} name="gender" />
          </FormCardGroup>
          <FormCardGroup type="card" text="Wohnsituation">
            <RadioValues selectedValue={houseSituation} possibleValues={HouseSituation} name="houseSituation" />
            <RadioValues selectedValue={landScapeSituation} possibleValues={LandScapeSituation} name="landScapeSituation" />
          </FormCardGroup>
          <FormCardGroup type="card" text="Ich betreue Tiere">
            <CheckboxValues selectedValues={isPate} possibleValues={SingleChoise} name="isPate" />
          </FormCardGroup>
          <FormCardGroup type="card" text="Ich gebe Tiere in Betreuung">
            <CheckboxValues selectedValues={isOwner} possibleValues={SingleChoise} name="isOwner" />
          </FormCardGroup>
          <FormInput name="birthday" text="Geburtsjahr" type="date" value={birthday} />
          <FormInput
            name="pricePerDayAtMe"
            min="0"
            max="20"
            text="Preis pro Tag bei mir"
            type="number"
            value={pricePerDayAtMe}
          />
          <FormInput name="pricePerNight" min="0" max="5" text="Zusätzlich pro Nacht" type="number" value={pricePerNight} />
          <FormInput
            name="pricePerDayAtYou"
            min="0"
            max="20"
            text="Preis pro Tag bei dir"
            type="number"
            value={pricePerDayAtYou}
          />
          <FormInput
            name="priceClean"
            min="0"
            max="15"
            text="Preis für Komplettreinigung"
            type="number"
            value={priceClean}
          />
          <FormTextarea text="Über mich" value={aboutMe} name="aboutMe" />
          <AutoComplete required place={place} onChange={address => userSettingsChange('place', address)} />
          <FormButton text="Speichern" />
        </AlertForm>
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.currentUserReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(UserSettings);



// WEBPACK FOOTER //
// ./src/pages/Usersettings/index.js